export default __webpack_public_path__ + "static/media/how-firecloud-works.c5dc297c.svg";